import { render, staticRenderFns } from "./DisplayItemType.vue?vue&type=template&id=eb541288"
import script from "./DisplayItemType.vue?vue&type=script&lang=js"
export * from "./DisplayItemType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports